module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_0_0@3x.2c8c0ec6.png";